(() => {
  const config = document.getElementById('dj-fall10-config');
  if (!config) return;
  const promotionEnd = Date.parse('2026-11-01T04:00:00Z');
  const remaining = promotionEnd - Date.now();
  if (remaining > 0 && remaining < 2147483647) {
    setTimeout(() => window.location.reload(), remaining + 250);
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && remaining > 0 && Date.now() >= promotionEnd) window.location.reload();
  });
  const eligible = new Set(JSON.parse(config.textContent).map(String));
  const code = 'FALL10';
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  async function synchronize(sections = []) {
    const read = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
    if (!read.ok) throw new Error('Unable to read cart');
    const cart = await read.json();
    const inSeason = Date.now() < promotionEnd;
    const qualifies = inSeason && cart.items.some(item => eligible.has(String(item.product_id)));
    const existing = (cart.discount_codes || []).map(item => item.code);
    const other = existing.filter(value => value.toUpperCase() !== code);
    const codes = qualifies ? [...other, code] : other;
    const changed = codes.join(',').toUpperCase() !== existing.join(',').toUpperCase();
    if (!changed) return null;
    const update = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({discount: codes.join(','), sections, sections_url: location.pathname})
    });
    if (!update.ok) throw new Error('Unable to update cart discount');
    return update.json();
  }
  window.djFall10 = {
    sync(sections = []) {
      const result = pending.catch(() => {}).then(() => synchronize(sections));
      pending = result;
      return result;
    }
  };
  async function refresh() {
    try {
      const data = await window.djFall10.sync();
      if (data) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } catch (error) { console.warn('FALL10', error); }
  }
  document.addEventListener('on:line-item:change', refresh);
  document.addEventListener('on:cart:add', refresh);
  refresh();
})();